// extracted by mini-css-extract-plugin
export default {"container":"leMwa_GF0GXAvy2Lf2es","body":"g35bc69O2JTW9CJMQFMA","error":"dZEWqSWzsF2K74Wd9d3z","alternatives":"irWnGczkjr9UT8VY4u9J"};